import React, { Component } from "react";
import { Card } from "components/Card/Card.jsx";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";
import DatePicker from "react-modern-calendar-datepicker";
import Select from "react-select";
import { apiCallRequest } from "../../redux/actions";
import { connect } from "react-redux";
import Button from "components/CustomButton/CustomButton.jsx";
import { PersianNumber } from "@thg303/react-persian";
import { NotificationManager } from "react-notifications";
import _, { bind } from "lodash";
import DFormSection from "./DFormSection";
import DCounterDisplay from "./DCounterDisplay";
const mapStateToProps = (state) => {
  return {
    fetching: state.fetching,
    response: state.response,
    error: state.error,
    customers: state.customers,
    drivers: state.drivers,
    services: state.services,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRequest: () => dispatch(apiCallRequest()),
  };
};

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total_price: 0,
      selected_order: [],
      selected_driver: undefined,
      driverOptions: this.generateOptionsFromDrivers(this.props.drivers),
      serviceOptions: this.generateOptionsFromServices(this.props.services),
      selectedDayStart: null,
      selectedDayEnd: null,
      total_price_service_date: 0,
      total_area_service_date: 0,
      selected_service_date: null,
    };

    this.generateOptionsFromDrivers =
      this.generateOptionsFromDrivers.bind(this);
    this.generateOptionsFromServices =
      this.generateOptionsFromServices.bind(this);
    this.getOrdersFromTo = this.getOrdersFromTo.bind(this);
    this.handleChangeDriver = this.handleChangeDriver.bind(this);
    this.handleChangeService = this.handleChangeService.bind(this);

    this.handleChangeServiceDate = this.handleChangeServiceDate.bind(this);
    this.showTotalTrasportPrice = this.showTotalTrasportPrice.bind(this);
    this.showTotalTrasportPriceService =
      this.showTotalTrasportPriceService.bind(this);
    this.showTotalDatePriceService = this.showTotalDatePriceService.bind(this);
    this.setSelectedDayStart = this.setSelectedDayStart.bind(this);
    this.getInputTextStart = this.getInputTextStart.bind(this);

    this.setSelectedDayEnd = this.setSelectedDayEnd.bind(this);
    this.getInputTextEnd = this.getInputTextEnd.bind(this);
  }

  getInputTextStart() {
    if (!this.state.selectedDayStart) return "";
    const { year, month, day } = this.state.selectedDayStart;
    return `${day}/${month}/${year}`;
  }

  setSelectedDayStart(date) {
    this.setState({ selectedDayStart: date });
  }

  getInputTextEnd() {
    if (!this.state.selectedDayEnd) return "";
    const { year, month, day } = this.state.selectedDayEnd;
    return `${day}/${month}/${year}`;
  }

  setSelectedDayEnd(date) {
    this.setState({ selectedDayEnd: date });
  }

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }

  //check if order is in factor range
  // (if driverid is not undefined so it has been participated)
  getOrdersFromTo(from, to, callback) {
    if (!_.isNumber(parseInt(from)) || !_.isNumber(parseInt(to))) {
      NotificationManager.error("شماره ها فاکتور را درست وارد کنید", "خطا");
      return;
    }
    if (from <= 0) {
      NotificationManager.error("شماره ها فاکتور را درست وارد کنید", "خطا");
      return;
    }
    if (to < from) {
      NotificationManager.error("فاکتور شروع باید کوچکتر از پایان باشد", "خطا");
      return;
    }
    callback();
  }

  generateOptionsFromDrivers(drivers = []) {
    let arr = [];
    for (let i = 0; i < drivers.length; i++) {
      if (drivers[i].isEnable)
        arr.push({
          value: drivers[i],
          label: drivers[i].firstName + " " + drivers[i].lastName,
        });
    }
    return arr;
  }

  generateOptionsFromServices(services) {
    return services.map((service) => ({
      value: service,
      label: `${service.name} -  قیمت: ${this.toPersianNumbers(
        this.formatNumberWithCommas(service.price)
      )} تومان , موجود: ${service.isDeleted ? "✗" : "✓"}`,
    }));
  }

  toPersianNumbers(num) {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return num.toString().replace(/\d/g, (x) => persianNumbers[x]);
  }

  formatNumberWithCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  showTotalTrasportPriceService() {
    let start = parseInt(this.start_invoice_number_service.value || 0);
    let end = parseInt(this.end_invoice_number_service.value || 0);
    console.log(this.state);
    let service =
      this.state.selected_service !== undefined
        ? this.state.selected_service.value._id
        : undefined;
    let that = this;
    this.getOrdersFromTo(start, end, function () {
      window.server.emit("total_service", start, end, service, (data) => {
        if (data.code == 200) {
          let res = JSON.parse(data.response);
          // console.log(res);
          // return;
          that.setState({
            total_price_service: res.price,
            total_area_service: res.area,
          });
        }
      });
    });
  }

  showTotalDatePriceService() {
    const { selectedDayEnd, selectedDayStart } = this.state;
    let service =
      this.state.selected_service_date !== undefined
        ? this.state.selected_service_date.value._id
        : undefined;
    let that = this;
    if (selectedDayStart == undefined || selectedDayEnd == undefined) {
      NotificationManager.error(
        "تاریخ های شروع و پایان را درست وارد کنید",
        "خطا"
      );
      return;
    }
    console.log(selectedDayEnd, selectedDayStart, service);
    window.server.emit(
      "total_service",
      undefined,
      undefined,
      service,
      selectedDayStart,
      selectedDayEnd,
      (data) => {
        if (data.code == 200) {
          that.setState({
            total_price_service_date: data.response.price,
            total_area_service_date: data.response.area,
          });
        }
      }
    );
  }

  showTotalTrasportPrice() {
    let start = parseInt(this.start_invoice_number.value || 0);
    let end = parseInt(this.end_invoice_number.value || 0);
    console.log(this.state);
    let driver =
      this.state.selected_driver !== undefined
        ? this.state.selected_driver.value._id
        : undefined;
    let that = this;
    this.getOrdersFromTo(start, end, function () {
      window.server.emit(
        "driver_total_transport",
        start,
        end,
        driver,
        (data) => {
          if (data.code == 200) {
            that.setState({ total_price: data.response });
          }
        }
      );
    });
  }

  handleChangeDriver(select) {
    this.setState({ selected_driver: select });
  }

  handleChangeService(select) {
    this.setState({ selected_service: select });
  }

  handleChangeServiceDate(select) {
    this.setState({ selected_service_date: select });
  }

  render() {
    console.log(this.state);
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col xs={4}>
              <Card
                title="پالایش راننده"
                category="شماره فاکتور برای محاسبه ایاب ذهاب را وارد کنید"
                content={
                  <div>
                    <Row className={"row-eq-height"}>
                      <Col md={12}>
                        <FormGroup>
                          <ControlLabel>راننده</ControlLabel>
                          <Select
                            value={this.state.selected_driver}
                            onChange={this.handleChangeDriver}
                            options={this.state.driverOptions}
                            placeholder="انتخاب راننده"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <ControlLabel>شروع</ControlLabel>
                        <FormControl
                          type="text"
                          // value={this.state.customer.lastName}
                          bsClass="form-control"
                          placeholder="شروع"
                          inputRef={(ref) => {
                            this.start_invoice_number = ref;
                          }}
                          onFocus={() => (this.start_invoice_number.value = "")}
                          defaultValue={this.state.start_invoice_number}
                          onChange={this.changeStartInvoiceNumber}
                        />
                      </Col>

                      <Col md={6}>
                        <ControlLabel>پایان</ControlLabel>
                        <FormControl
                          type="text"
                          // value={this.state.customer.lastName}
                          bsClass="form-control"
                          placeholder="پایان"
                          inputRef={(ref) => {
                            this.end_invoice_number = ref;
                          }}
                          onFocus={() => (this.end_invoice_number.value = "")}
                          defaultValue={this.state.end_invoice_number}
                          onChange={this.changeEndInvoiceNumber}
                        />
                      </Col>
                      <Col xs={6} style={{ marginTop: "10px" }}>
                        <Button
                          bsStyle="info"
                          onClick={this.showTotalTrasportPrice}
                          pullRight
                          fill
                          type="button"
                        >
                          نمایش
                        </Button>
                      </Col>
                      <Col xs={6}>
                        <div
                          id="counter_container"
                          className={["text-center", "result-font"]}
                          style={{
                            verticalAlign: "middle",
                            margin: "10px auto",
                          }}
                        >
                          <span>هزینه:</span>
                          <PersianNumber>
                            {this.formatNumberWithCommas(
                              this.state.total_price || 0
                            )}
                          </PersianNumber>
                        </div>
                      </Col>
                    </Row>
                  </div>
                }
              />
            </Col>

            <Col xs={8}>
              <Card
                title="پالایش خدمات با شماره فاکتور"
                category="شماره فاکتور برای محاسبه خدمات را وارد کنید"
                content={
                  <div>
                    <Row className={"row-eq-height"}>
                      <Col md={12} style={{ zIndex: 999 }}>
                        <FormGroup>
                          <ControlLabel>خدمات</ControlLabel>
                          <Select
                            value={this.state.selected_service}
                            onChange={this.handleChangeService}
                            options={this.state.serviceOptions}
                            placeholder="انتخاب راننده"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <ControlLabel>شماره فاکتور شروع</ControlLabel>
                        <FormControl
                          type="text"
                          bsClass="form-control"
                          placeholder="شروع"
                          inputRef={(ref) => {
                            this.start_invoice_number_service = ref;
                          }}
                          onFocus={() =>
                            (this.start_invoice_number_service.value = "")
                          }
                          defaultValue={this.state.start_invoice_number_service}
                          onChange={this.changeStartInvoiceNumberService}
                        />
                      </Col>

                      <Col md={6}>
                        <ControlLabel>شماره فاکتور پایان</ControlLabel>
                        <FormControl
                          type="text"
                          bsClass="form-control"
                          placeholder="پایان"
                          inputRef={(ref) => {
                            this.end_invoice_number_service = ref;
                          }}
                          onFocus={() =>
                            (this.end_invoice_number_service.value = "")
                          }
                          defaultValue={this.state.end_invoice_number_service}
                          onChange={this.changeEndInvoiceNumberService}
                        />
                      </Col>

                      <Col xs={3} style={{ marginTop: "10px" }}>
                        <Button
                          bsStyle="info"
                          onClick={this.showTotalTrasportPriceService}
                          pullRight
                          fill
                          type="button"
                        >
                          نمایش
                        </Button>
                      </Col>
                      <Col xs={3}>
                        <div
                          id="counter_container"
                          className={["text-center", "result-font"]}
                          style={{
                            verticalAlign: "middle",
                            margin: "10px auto",
                          }}
                        >
                          <span>متراژ:</span>
                          <PersianNumber>
                            {this.state.total_area_service || 0}
                          </PersianNumber>
                        </div>
                      </Col>
                      <Col xs={3}>
                        <div
                          id="counter_container"
                          className={"text-center"}
                          style={{
                            verticalAlign: "middle",
                            margin: "10px auto",
                          }}
                        >
                          <span>قیمت:</span>
                          <PersianNumber>
                            {this.formatNumberWithCommas(
                              this.state.total_price_service || 0
                            )}
                          </PersianNumber>
                        </div>
                      </Col>
                    </Row>
                  </div>
                }
              />
            </Col>
            <Col xs={12}>
              <Card
                title="پالایش خدمات با تاریخ"
                category="تاریخ شروع و پایان را برای محاسبه خدمات وارد کنید"
                content={
                  <div>
                    <Row className={"row-eq-height"}>
                      <Col style={{ zIndex: 999 }} md={6}>
                        <FormGroup>
                          <ControlLabel>خدمات</ControlLabel>
                          <Select
                            value={this.state.selected_service_date}
                            onChange={this.handleChangeServiceDate}
                            options={this.state.serviceOptions}
                            placeholder="انتخاب خدمت"
                          />
                        </FormGroup>
                      </Col>

                      <Col xs={3} md={3}>
                        <FormGroup>
                          <ControlLabel>تاریخ شروع گزارش</ControlLabel>
                          <div>
                            <DatePicker
                              value={this.selectedDayStart}
                              calendarPopperPosition="bottom"
                              onChange={this.setSelectedDayStart}
                              inputPlaceholder="تاریخ شروع"
                              inputClassName="DatePicker__input -rtl custom-date-picker-input"
                              formatInputText={this.getInputTextStart}
                              shouldHighlightWeekends
                              locale="fa"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col xs={3} md={3}>
                        <FormGroup>
                          <ControlLabel>تاریخ پایان گزارش</ControlLabel>
                          <div>
                            <DatePicker
                              value={this.selectedDayEnd}
                              onChange={this.setSelectedDayEnd}
                              shouldHighlightWeekends
                              calendarPopperPosition="bottom"
                              inputPlaceholder="تاریخ پایان"
                              inputClassName="DatePicker__input -rtl custom-date-picker-input"
                              formatInputText={this.getInputTextEnd}
                              locale="fa"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <Col xs={3} style={{ marginTop: "10px" }}>
                          <Button
                            bsStyle="info"
                            onClick={this.showTotalDatePriceService}
                            pullRight
                            fill
                            type="button"
                          >
                            نمایش
                          </Button>
                        </Col>
                        <Col xs={3}>
                          <div
                            id="counter_container"
                            className={["text-center", "result-font"]}
                            style={{
                              verticalAlign: "middle",
                              margin: "10px auto",
                            }}
                          >
                            <span>متراژ:</span>
                            <PersianNumber>
                              {this.state.total_area_service_date || 0}
                            </PersianNumber>
                          </div>
                        </Col>
                        <Col xs={3}>
                          <div
                            id="counter_container"
                            className={"text-center"}
                            style={{
                              verticalAlign: "middle",
                              margin: "10px auto",
                            }}
                          >
                            <span>قیمت:</span>
                            <PersianNumber>
                              {this.formatNumberWithCommas(
                                this.state.total_price_service_date || 0
                              )}
                            </PersianNumber>
                          </div>
                        </Col>
                      </Col>
                    </Row>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const DashboardConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard);
export default DashboardConnect;
